import Amex from './amex.js';
import ApplePay from './applePay.js';
import Default from './default.js';
import Discover from './discover.js';
import Jcb from './jcb.js';
import Maestro from './maestro.js';
import MasterCard from './masterCard.js';
import Visa from './visa.js';

var Payment = {
  Amex: Amex,
  ApplePay: ApplePay,
  Default: Default,
  Discover: Discover,
  Jcb: Jcb,
  Maestro: Maestro,
  MasterCard: MasterCard,
  Visa: Visa
};

export { Payment as default };
//# sourceMappingURL=index.js.map
